import * as Customer from '@/services/rest-api/lib/customer/customer'

export default {
  name: 'customer_id',
  showKey: 'customer',
  type: 'value-help-v2',
  label: 'Pelanggan',
  placeholder: 'Pilih Nama Pelanggan',
  trackBy: 'id',
  displayedBy: 'name',
  listGetter: Customer.getExternal,
  hasStoreAction: false,
  tableFields: [
    {
      label: 'Nama',
      name: 'name',
      key: 'name',
      isSortable: true,
    },
    {
      label: 'ID',
      name: 'number',
      key: 'number',
      isSortable: true,
    },
    {
      label: 'Address',
      name: 'address',
      key: 'address',
      thStyle: 'width: 350px',
    },
  ],
}